import React, { Component } from 'react'
import moment from 'moment'
import { styles, translateAlimentLibelle } from "../../../../../ReactConst"
import { StyleRoot } from 'radium';
import iconValider from '../../../../../styles/img/icon-check-white.svg';
import Img from 'react-image'
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import _ from 'lodash'
import { withTranslation } from 'react-i18next';
const IconValider = () => <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />

function Arrivee({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic">
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateArrivee).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatRepas == "BEAUCOUP" ? t('transmission.ate_well') : event.etatRepas == "CORRECTEMENT" ? t('transmission.ate_correctly') : t('transmission.ate_little')}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatSommeil === "MAL" ? t('transmission.slept_badly') : t('transmission.slept_well')}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatSante == 'A_SURVEILLER' ? t('transmission.to_monitor') : event.etatSante == 'INQUIETANT' ? t('transmission.worrying') : t('transmission.nothing_to_report')}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.sousTraitement ? t('transmission.under_treatment') : t('transmission.not_under_treatment')}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{t('transmission.will_leave_with') + " " + (event.prenomParent ? event.prenomParent : event.prenomTierAutorise)}</span>
        </label>
      </div>
    </div>
  )
}
function Depart({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3">
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.timeDepart).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{t('transmission.picked_up_with') + " " + (event.prenomParent ? event.prenomParent : event.prenomTierAutorise)}</span>
        </label>
      </div>
    </div>
  )
}
function Sieste({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{t('transmission.from') + ' ' + moment(event.offsetDateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{t('transmission.to') + ' ' + moment(event.offsetDateTimeFin).format("HH[h]mm")}</span>
        </label>
      </div>
    </div>
  )
}
function Repas({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        {event.aliments.map((aliment, index) =>
          event.quantite ?
            <label key={index} class="rounded15 box-shadow d-flex justify-content-center">
              <span class="name">{translateAlimentLibelle(aliment.libelle, t) + " " + event.quantite + "ml"}</span>
            </label>
            :
            <label key={index} class="rounded15 box-shadow d-flex justify-content-center">
              <span class="name">{translateAlimentLibelle(aliment.libelle, t)}</span>
            </label>
        )}
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatRepas && event.etatRepas === "PEU" ? t('transmission.ate_little') : event.etatRepas === "CORRECTEMENT" ? t('transmission.ate_correctly') : t('transmission.ate_well')}
          </span>
        </label>
      </div>
    </div>
  )
}
function Activite({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          {event.activiteType === "AUTRE" ? <span class="name">{event.libelle}</span> : <span class="name">{formatActivite(event.activiteType, t)}</span>}
        </label>
      </div>
    </div>
  )
}
function Incident({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center" >
          <span class="name">{name}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          {event.typeIncident === "AUTRE" ? <span class="name">{event.remarque}</span> : <span class="name">{formatIncident(event.typeIncident, t)}</span>}
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatSante && event.etatSante === "RIEN_DE_GRAVE" ? t('transmission.nothing_serious') : event.etatSante === "INQUIETANT" ? t('transmission.worrying') : t('transmission.to_monitor')}</span>
        </label>
      </div>
    </div>
  )
}
function PetitCoin({ event, name, t }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.support && event.support === "COUCHE" ? t('transmission.diaper') : event.support === "POT" ? t('transmission.potty') : t('transmission.toilet')}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.aspect && event.aspect === "NORMAL" ? t('transmission.normal') : t('transmission.abnormal')}</span>
        </label>
      </div>
    </div>
  )
}

function formatActivite(string, t) {
  if (t) {
    const map = {
      "PATE_A_MODELER": t('timeline.modeling_clay'),
      "PEINTURE": t('timeline.painting'),
      "DANSE": t('timeline.dance'),
      "PISCINE": t('timeline.pool'),
      "LECTURE": t('timeline.reading'),
      "SORTIE": t('timeline.outing'),
      "ACTIVITE_MANUELLE": t('timeline.manual_activities'),
      "AUTRE": t('timeline.other')
    };
    return map[string] || "";
  }
  switch (string) {
    case "PATE_A_MODELER": return "Pâte à modeler"
    case "PEINTURE": return "Peinture"
    case "DANSE": return "Danse"
    case "PISCINE": return "Piscine"
    case "LECTURE": return "Lecture"
    case "SORTIE": return "Sortie"
    case "ACTIVITE_MANUELLE": return "Activité Manuelle"
    case "AUTRE": return "Autre"
    default: return ""
  }
}
function formatIncident(string, t) {
  if (t) {
    const map = {
      "FIEVRE": t('timeline.fever'),
      "VOMI": t('timeline.vomit'),
      "TOUX": t('timeline.cough'),
      "BLESSURE": t('timeline.injury'),
      "BOUTONS": t('timeline.rash')
    };
    return map[string] || "";
  }
  switch (string) {
    case "FIEVRE": return "Fièvre"
    case "VOMI": return "Vomi"
    case "TOUX": return "Toux"
    case "BLESSURE": return "Blessure"
    case "BOUTONS": return "Boutons"
    default: return ""
  }
}

class ModalTransmission extends Component {
  constructor(props) {
    super(props)

    this.state = {
      styleFadeIn: true,
    }
    this.closeModal = this.closeModal.bind(this);
  }
  closeModal = () => {
    this.setState({
      styleFadeIn: false
    })
    setTimeout(() => {
      this.props.onCloseModaleTransmission()
    }, 400);
  }

  renderEvent(event) {
    let typeEvent = event.typeEvent;
    const { t } = this.props;
    switch (typeEvent) {
      case "ARRIVEE":
        return <Arrivee event={event.event} name={t('timeline.arrival')} t={t} />
      case "ACTIVITE":
      case "PATE_A_MODELER":
      case "PEINTURE":
      case "PEINTURE":
      case "DANSE":
      case "PEINTURE":
      case "SORTIE":
      case "PISCINE":
      case "LECTURE":
      case "ACTIVITE_MANUELLE":
      case "AUTRE":
        return <Activite event={event.event} name={t('timeline.activity')} t={t} />
      case "DEPART":
        return <Depart event={event.event} name={t('timeline.departure')} t={t} />
      case "INCIDENT":
      case "FIEVRE":
      case "VOMI":
      case "TOUX":
      case "BLESSURE":
      case "BOUTONS":
      case "AUTRE":
        return <Incident event={event.event} name={t('timeline.incident')} t={t} />
      case "SIESTE":
        return <Sieste event={event.event} name={t('timeline.nap')} t={t} />
      case "REPAS":
      case "BIBERON":
      case "REPAS_PEU":
      case "REPAS_CORRECTEMENT":
      case "REPAS_BEAUCOUP":
        return <Repas event={event.event} name={t('timeline.meal')} t={t} />
      case "PETITE_COMMISSION":
      case "GROSSE_COMMISSION":
        return <PetitCoin event={event.event} name={typeEvent === "PETITE_COMMISSION" ? t('timeline.pee') : t('timeline.stool')} t={t} />
      default:
        return ""
    }
  }

  render() {
    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
    const { eventsDetails, onCloseModaleTransmission, transmissionLoading } = this.props
    return (
      <StyleRoot>
        <div class="modal show fade modal-skin modal-large" id="modalTransmission" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" tabIndex="-1" role="dialog"
          style={this.state.styleFadeIn === true ? styles.bounce : styles.bounce2}
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <form>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <img src="img/close.svg" class="img-fluid" alt="" />
                </button>
                <div class="modal-body fiche-enfant">
                  <h2 class="modal-title mb-3">{this.props.t('fiche_enfant.transmission.title')}</h2>
                  <p class="bottom-space"></p>
                  <section class="content-section">
                    <DotLoader
                      size={100}
                      color={"#ff7d26"}
                      css={override}
                      loading={transmissionLoading && _.isEmpty(eventsDetails)}
                    />
                    <div class="row row-contre-indic align-items-stretch" >
                      {eventsDetails.map(event =>
                        this.renderEvent(event)
                      )}
                    </div>
                  </section>
                  <div class="d-flex justify-content-center">
                    <div class="row align-items-center">
                      <button onClick={this.closeModal} type="button" class="btn-gradient btn-valid margin-left" data-dismiss="modal"><IconValider /> OK</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    )
  }
}

export default withTranslation()(ModalTransmission);